export default __webpack_public_path__ + "static/media/logo.b3b08686.png";